namespace Matrix.Dashboards {
    export class DashboardUserColumns {
        static columnsKey = 'Dashboards.DashboardUser';
    }
}
